export default function prepareIncomingData (data) {
	try {
		let temp;

		if (typeof data === 'string') {
			temp = JSON.parse(data);
		} else {
			temp = JSON.parse(JSON.stringify(data));
		}

		return temp;
	} catch (err) {
		console.group('Incorrect data format');
		console.error(err, '\n');
		console.log(data, '\n');
		console.groupEnd('Incorrect data format');

		return new Error('Некорректный формат данных');
	}
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_utils/prepareIncomingData.js